import { shape, bool, func, string } from 'prop-types';
import classnames from 'classnames';
import { Icon } from 'semantic-ui-react';
import React from 'react';

import MessageFile from './MessageFile';
import MessageMedia from './MessageMedia';
import styles from './MessageItem.less';

const MessageParent = ({ message, isDoctor, setJumpMessage, userUuid }) => {
  const onJumpMessage = () => setJumpMessage(message);

  const isHtml = text => text?.slice(0, 6) === '<body>';

  const renderReplyName = () => {
    if (message?.parent?.user === message?.user) {
      if (isDoctor) return 'yourself';
      return 'themself';
    }
    if (message?.parent?.user === userUuid) return 'you';
    return message?.parent?.metadata?.senderName;
  };

  if (!message?.parent) return null;

  return (
    <>
      <div className={classnames({ [styles.wrapParentReplyText]: true, right: isDoctor })}>
        <Icon name="reply" />
        {isDoctor ? 'You ' : `${message.metadata.senderName} `}
        replied to
        {` ${renderReplyName()}`}
      </div>
      <div
        className={classnames({
          [styles.wrapParent]: !message.parent.message?.media,
          right: isDoctor,
          [styles.wrapParentImage]: message.parent.message?.media,
        })}
        // onClick={() => onJumpMessage(message.parent)}
      >
        {message.parent.message?.text && isHtml(message.parent.message?.text) ? (
          <div
            className={styles.wrapHtmlReply}
            dangerouslySetInnerHTML={{
              __html: message.parent.message?.text,
            }}
          />
        ) : (
          message.parent.message?.text
        )}
        {message.parent.message?.media && (
          <MessageMedia
            disableClick
            message={message.parent}
            conversationId={message.parent.metadata?.conversationId}
          />
        )}
        {message.parent.message?.file && <MessageFile disableClick message={message.parent} />}
      </div>
    </>
  );
};

MessageParent.propTypes = {
  message: shape({}).isRequired,
  isDoctor: bool.isRequired,
  setJumpMessage: func.isRequired,
  userUuid: string.isRequired,
};

export default MessageParent;
